module.exports = __webpack_public_path__ + "img/w19.bb6a4833.svg";